<template>
    <b-card no-body :class="options.classes" class="c-card-line-chart">
        <b-card-body class="pb-0">
            <slot name="body"></slot>
            <h4 class="mb-0">{{value}}</h4>
            <p>{{caption}}</p>
        </b-card-body>
        <ChartBar
                v-if="chart.labels !== undefined && chart.sets !== undefined"
                :labels="chart.labels"
                :sets="chart.sets"
                :chartId="chartId"
                class="chart-wrapper px-3"></ChartBar>
    </b-card>
</template>

<script>
    import ChartBar from './ChartBar'
    export default {
        name: 'CardChartBar',
        components: {
            ChartBar
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        classes: ''
                    }
                }
            },
            chartId: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            value: {
                type: String|Number,
                default: ''
            },
            chart: {
                type: Object,
                default: function() {
                    return {
                    }
                }
            }
        },
        data: () => {
            return {
            }
        }
    }
</script>
